export default {
    sim_provider_create_title: "Create SIM Provider",
    sim_provider_same_name_exits: "A SIM Provider with same name exists already",
    sim_provider_create_success_message: "The SIM Provider has been created",
    sim_provider_edit_title: "Edit SIM Provider",
    sim_provider_edit_success_message: "The SIM Provider has been edited",
    sim_provider_name: "Name",
}